// import "../../pages/order-form/OrderForm.css";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Select from "react-select";
import { Button } from "@app/components";
import * as Yup from 'yup';
import { useFormik } from "formik";
import { getAllActiveFranchise, getSubjectsByFranchise } from "@app/services/franchise";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import { setPreferenceData, setStep, loadModules, loadPathway } from "@app/store/reducers/learningPathway";
import { getAllActiveModulesWithSetsBySubject } from "@app/services/module";
import { createLearningPathway, getPathwayConfigurationById, updatePathwayConfiguration } from "@app/services/learningPathway";
import { getAllActiveSubjects } from "@app/services/subject";
import { decodeId } from "@app/helpers/base64url";

const SetPreferences = () => {

	const [franchises, setFranchises] = useState([]);
	const [selectedFranchise, setSelectedFranchise] = useState('');
	const [selectedSubject, setSelectedSubject] = useState('');
	const [isLoadingFranchise, setLoadingFranchise] = useState(false);
    const [subjects, setSubjects] = useState([]);
    const statuses = [{value:'active', label:'Active'}, {value:'inactive', label:'Inactive'}, {value:'draft', label:'Draft'}]
    const lpStore = useSelector((state: any) => state.learningPathway);
    const role = useSelector((state: any) => state.auth.selectedRole.slug);
    const dispatch = useDispatch();
	const { type, id: encodedId } = useParams();
    const id = encodedId ? decodeId(encodedId) : null;
    const [isLoading, setLoading] = useState(false);
    const navigate = useNavigate();

	useEffect(() => {
        dispatch(setStep(1));
        if(id){
            getPathwayConfigurationByIdAPI(id);
        }
        getAllActiveFranchiseData();
    },[]);

    const getPathwayConfigurationByIdAPI = async (id) => {
        try {
            const resp = await getPathwayConfigurationById(id);
            if (resp?.success === true) {
                let franchise_id = resp?.collections?.franchise_id
                if(role !== 'admin' && role !== 'super-admin' && resp?.collections?.franchise_id == 0){
                    franchise_id = null
                }
                dispatch(setPreferenceData({
                    name: resp?.collections?.name,
                    franchise_id: franchise_id,
                    franchise_name: resp?.collections?.franchise_id !== 0 ? resp?.collections?.franchise_name : 'FCL Default',
                    subject_id: resp?.collections?.subject_id,
                    subject_name: resp?.collections?.subject_name,
                    status: resp?.collections?.status,
                    student_assigned: resp?.collections?.student_assigned,
                }));
                dispatch(loadPathway(resp?.collections?.pathway))
                if(resp?.collections?.franchise_id !== 0){
                    getFranchiseSubjects(resp?.collections?.franchise_id)
                }else if(resp?.collections?.franchise_id == 0){
                    getAllActiveSubjectsAPI()
                }
            } else {
                navigate('/learning-pathway');
                toast.error('Something went wrong!');
            }
        } catch (error: any) {
            toast.error(error?.message || 'Internal server error');
        }
    };

	const getAllActiveFranchiseData = async () => {
        try {
            setLoadingFranchise(true);
            const resp = await getAllActiveFranchise();
            if (resp?.success === true) {
                setLoadingFranchise(false);
                if(role === 'admin' || role === 'super-admin') {
                    setFranchises([{id: 0, name: 'FCL Default'}, ...resp?.collections]);
                }else{
                    setFranchises(resp?.collections);
                }
                
                if(!id && lpStore?.franchise_id && lpStore?.franchise_id != 0){
                    getFranchiseSubjects(lpStore?.franchise_id)
                }else if(!id && lpStore?.franchise_id == 0){
                    getAllActiveSubjectsAPI()
                }
            } else {
                setLoadingFranchise(false);
                toast.error(resp?.errors[0]?.msg);
            }
        } catch (error: any) {
            setLoadingFranchise(false);
            toast.error(error?.message || 'Internal server error');
        }
    };

    const getFranchiseSubjects = async (franchise_id) => {
        try {
            setLoading(true)
            const resp = await getSubjectsByFranchise(franchise_id)
            if (resp.success === true) {
                setLoading(false)
                setSubjects(resp?.collections.filter((sub) => sub.status == 'active'))
            } else {
                setLoading(false)
                toast.error(resp?.errors[0]?.msg);
            }
        } catch (error: any) {
            setLoading(false)
            toast.error(error?.message || 'Internal server error');
        }
    };

    const getAllActiveSubjectsAPI = async () => {
        try {
            const resp = await getAllActiveSubjects()
            if (resp.success === true) {
                const updatedArray = resp.collections.map(obj => ({ ...obj, subject_id: obj.id }));
                setSubjects(updatedArray);
            } else {
                toast.error(resp?.errors[0]?.msg);
            }
        } catch (error: any) {
            toast.error(error?.message || 'Internal server error');
        }
    };

    const getModulesWithSetsBySubjectId = async (subject_id) => {
        try {
            const resp = await getAllActiveModulesWithSetsBySubject(subject_id)
            if (resp.success === true) {
                dispatch(loadModules(resp?.collections))
            } else {
                toast.error(resp?.errors[0]?.msg);
            }
        } catch (error: any) {
            toast.error(error?.message || 'Internal server error');
        }
    };

	const { handleChange, values, handleSubmit, touched, errors, setFieldValue} = useFormik({
        initialValues: {
            name: lpStore?.name || '',
            franchise_id: lpStore?.franchise_id ?? '',
            subject_id: lpStore?.subject_id || '',
            status: lpStore?.status || ''
        },
        validationSchema: Yup.object({
            name: Yup.string().trim().required('Please enter pathway name'),
            franchise_id: Yup.string().required('Please select franchise'),
            subject_id: Yup.string().required('Please select subject'),
            status: Yup.string().required('Please select status'),
        }),
        onSubmit: (values) => {
            const foundSubject = subjects.find(subject => subject.subject_id == values?.subject_id) 
            if(!foundSubject){
                toast.error('The selected franchise does not have this subject assigned. Please choose another franchise.');
            } else {
                learningPathwayStep1({...values, step: 1});
            }   
        },
        enableReinitialize: true,
    });

    const learningPathwayStep1 = async(payload) => {
        try {
            setLoading(true);
            let resp;
            if(type === 'edit'){
                payload = {...payload, learning_pathway_id: id}
                resp = await updatePathwayConfiguration(payload);
            }else{
                resp = await createLearningPathway(payload);
            }
            if(resp.success === true){
                setLoading(false);
                getModulesWithSetsBySubjectId(values.subject_id)
                dispatch(setPreferenceData({    ...values, 
                                                franchise_name: selectedFranchise != '' ? selectedFranchise : lpStore?.franchise_name, 
                                                subject_name: selectedSubject != '' ? selectedSubject : lpStore?.subject_name,
                                                student_assigned: lpStore?.student_assigned
                                            }));
                dispatch(setStep(2));
            }else{
                setLoading(false);
                toast.error(resp?.errors[0]?.msg);
            }
        } catch (error: any) {
            setLoading(false);
            toast.error(error?.message || 'Internal server error')
        }
    }

    const handleSubjectChange = (e) => {
        setFieldValue('subject_id', e.target.value)
        
        // To get the name (text content) of the selected option
        const selectedOption = e.target.options[e.target.selectedIndex];
        setSelectedSubject(selectedOption.text);
    }

	return (
		<>
			<div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card card-primary">
                            <form onSubmit={handleSubmit}>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="form-group">
                                                <label htmlFor="name"><b>Pathway Name </b><span className="required">*</span></label>
                                                <Form.Control 
                                                    type="text" 
                                                    className="form-control" 
                                                    id="exampleInputEmail1" 
                                                    placeholder="Enter Pathway Name"
                                                    name="name" 
                                                    onChange={handleChange} 
                                                    value={values.name}
                                                />
                                                {(touched.name && errors.name) && (
                                                    <div className="text-danger">
                                                        {errors.name}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="form-group">
                                                <label htmlFor="franchise_id"><b> Franchise </b><span className="required">*</span></label>
                                                <Select
                                                    // className="form-control"
                                                    name="franchise_id"
                                                    placeholder="Select Franchise"
                                                    options={franchises}
                                                    getOptionValue={(option)=>`${option['id']}`}
                                                    getOptionLabel={(option)=>`${option['name']}`}
                                                    onChange={ (option) => { 
														handleChange
                                                        if(option){
                                                            setFieldValue("franchise_id", option.id)
															setSelectedFranchise(option?.name)
                                                            if(option?.id != 0){
                                                                getFranchiseSubjects(option.id)
                                                            }else{
                                                                getAllActiveSubjectsAPI()
                                                            } 
                                                        }else{
                                                            setFieldValue("franchise_id", '')
                                                            setFieldValue("subject_id", '')
															setSelectedFranchise('')
                                                            setSubjects([])
                                                        }
                                                    }}
                                                    formatOptionLabel={(option) => (
                                                        <div style={{ fontWeight: option.id === 0 ? 700 : '' }}>
                                                            {option.name}
                                                        </div>
                                                    )}
                                                    value={franchises.filter(function(option) {
                                                        return option.id === values.franchise_id;
                                                    })}
                                                    isLoading={isLoadingFranchise}
                                                    // isClearable={true}
                                                    // isDisabled={id != null && values.franchise_id != 0 }
                                                />
                                                {(touched.franchise_id && errors.franchise_id) && (
                                                    <div className="text-danger">
                                                        {errors.franchise_id}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="form-group">
                                                <label htmlFor="subject_id"><b> Subject </b><span className="required">*</span></label>
                                                <select
                                                    className="form-control"
                                                    name="subject_id"
                                                    onChange={(e) => handleSubjectChange(e)}
                                                    value={values.subject_id}
                                                    disabled={id != null}
                                                >
                                                    <option value=""> Please select subject</option>
                                                    {subjects.map((obj) => (
                                                        <option key={obj.subject_id} value={obj.subject_id}>
                                                            {obj.name}
                                                        </option>
                                                    ))}
                                                </select>
                                                {(touched.subject_id && errors.subject_id) && (
                                                    <div className="text-danger">
                                                        {errors.subject_id}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="form-group">
                                                <label htmlFor="exampleInputEmail1"><b>Status </b><span className="required">*</span></label>
                                                <select 
                                                    className="form-control"
                                                    name="status"
                                                    onChange={handleChange} 
                                                    value={values.status}
                                                >
                                                    <option value="">--Please select--</option>
                                                    {statuses.length > 0 && statuses.map((obj) => (
                                                        <option key={obj.value} value={obj.value}>
                                                            {obj.label}
                                                        </option>
                                                    ))}
                                                </select>
                                                {(touched.status && errors.status) && (
                                                    <div className="text-danger">
                                                        {errors.status}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
								<div className="card-footer">
                                    <Button className="btn btn-default mr-2" onClick={() => navigate(-1)}>Cancel</Button>
                                    <Button type="submit" isLoading={isLoading} className="btn btnLP">Next </Button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
		</>
	);
};

export default SetPreferences;